<template>
  <question-card
    class="preffered-term-step"
    hide-button
  >
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div class="preffered-term-step__answers md-layout">
      <span
        class="preffered-term-step__answer-item answer-item
          md-layout-item md-medium-size-33 md-xsmall-size-100"
        :class="{ 'answer-item_checked': questionnaireLead.MortgageTerm === answers.thirty }"
        @click="answer(answers.thirty)"
      >
        {{UIComponentData.Choice1.Translations[questionnaireLead.Language]}}
      </span>
      <span
        class="preffered-term-step__answer-item answer-item
          md-layout-item md-medium-size-33 md-xsmall-size-100"
        :class="{ 'answer-item_checked': questionnaireLead.MortgageTerm === answers.twentyFive }"
        @click="answer(answers.twentyFive)"
      >
        {{UIComponentData.Choice2.Translations[questionnaireLead.Language]}}
      </span>
      <span
        class="preffered-term-step__answer-item answer-item
          md-layout-item md-medium-size-33 md-xsmall-size-100"
        :class="{ 'answer-item_checked': questionnaireLead.MortgageTerm === answers.twenty }"
        @click="answer(answers.twenty)"
      >
        {{UIComponentData.Choice3.Translations[questionnaireLead.Language]}}
      </span>
      <span
        class="preffered-term-step__answer-item answer-item
          md-layout-item md-medium-size-33 md-xsmall-size-100"
        :class="{ 'answer-item_checked': questionnaireLead.MortgageTerm === answers.fifteen }"
        @click="answer(answers.fifteen)"
      >
        {{UIComponentData.Choice4.Translations[questionnaireLead.Language]}}
      </span>
      <span
        class="preffered-term-step__answer-item answer-item
          md-layout-item md-medium-size-33 md-xsmall-size-100"
        :class="{ 'answer-item_checked': questionnaireLead.MortgageTerm === answers.ten }"
        @click="answer(answers.ten)"
      >
        {{UIComponentData.Choice5.Translations[questionnaireLead.Language]}}
      </span>
    </div>
    <div class="preffered-term-step__note">
        {{UIComponentData.Note.Translations[questionnaireLead.Language]}}
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ANSWERS } from '@/utils/constants/common';
import QuestionCard from '@/components/QuestionCard.vue';

export default {
  name: 'preffered-term-step',
  components: {
    QuestionCard,
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  data: () => ({
    answers: ANSWERS.prefferedTerms,
  }),
  methods: {
    ...mapActions(['mutateLead']),
    async answer(value) {
      this.questionnaireLead.MortgageTerm = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
  }
};
</script>

<style lang="scss">
@import '~@/styles/mixins';
@import '~@/styles/variables';

.preffered-term-step {
  &__answers {
    max-width: 440px;
    margin: 0 auto;
    justify-content: center;
    display: flex;
    flex-flow: wrap;
  }

  &__answer-item {

    &:not(:last-child) {
      border-right: $quest-icon-splitter-border;
    }
  }

  &__note {
    text-align: center;
    margin-top: 50px;
    font: {
      family: 'Avenir Next';
      weight: normal;
      size: 16px;
    }
    color: $grey;
  }


    &__answer-item {
      &:not(:last-child) {
          border: {
            bottom: $quest-icon-splitter-border;
          }
        }
      padding: 20px;
      white-space: nowrap;
      cursor: pointer;
      font-family: Roboto;
      font-weight: 500;
      font-size: 22px;
      line-height: 26px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      color: $primary-blue;
      text-align: center;
      padding-left: 25px;
      padding-right: 25px;
      @media (max-width: 387px) {
        padding-left: 27px;
        padding-right: 27px;
      }
      @media (max-width: 697px) {
        padding-left: 29px;
        padding-right: 29px;
      }

      &:nth-child(1) {
        border-bottom: $quest-icon-splitter-border;
        @media (max-width: 387px) {
          border-right: none;
        }
      }

      &:nth-child(2) {
        border-bottom: $quest-icon-splitter-border;
        @media (max-width: 697px) {
          border-right: none;
        }
      }

      &:nth-child(3) {
        border: {
          bottom: $quest-icon-splitter-border;
        }
        border-right: none;
      }
      &:nth-child(4) {
        border-left: none;
        border-bottom: $quest-icon-splitter-border;
        @media (max-width: 697px) {
          border-right: none;
        }
        @media (max-width: 697px) and (min-width: 387px){
          border-left: $quest-icon-splitter-border;
        }
        @media (min-width: 696px) {
          border-bottom: none;
        }
      }
      &:nth-child(5) {
        border-bottom: none
      }

    }

}
</style>
